import { makeAutoObservable } from 'mobx'
// import { RootStore } from 'mobx-stores'
import { CustomerAggregateDTO } from 'models/customers'
import { DepartmentsDTO } from 'models/departments'

export class CustomersStore {
  private rootStore: any

  constructor(rootStore: any) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  //OBSERVABLES
  private store: Partial<CustomerAggregateDTO> = {

  }

  // ACTIONS
  public setStore = (store: Partial<CustomerAggregateDTO>): void => {
    this.store = store
  }
  public setStoreProps = (props: Partial<DepartmentsDTO>): void => {
    this.setStore({ ...this.store, ...props })
  }

  public openCustomer = (customerId: string): void => {
    const { push } = this.rootStore.routingStore;
    push('/statistics/customer-revenue/' + customerId);
  }

  // COMPUTED
  public get departmentStore(): Partial<CustomerAggregateDTO> {
    return this.store
  }

  public getAllCustomers = async (customerId: string): Promise<CustomerAggregateDTO> => {
    const store = await this.rootStore.generalStore.api.customersApi.getAllCustomers();
    if (!store) return;
    this.setStore(store);
  }

  public resetStore = (): void => {
    this.setStore({});
  }
}
